import { Text, Heading } from "@amzn/storm-ui";
import React from "react";
import styled from "styled-components";

import { FullHeightDivFlexCenter } from "./common/styled.components";

const TextAlignCenterDiv = styled.div`
    text-align: center;
    max-width: 75vh;
`;

export const ContentUnavailable: React.FunctionComponent<{
    message: string;
}> = ({ message }) => {
    return (
        <FullHeightDivFlexCenter
            id="content-unavailable"
            data-testid="content-unavailable"
        >
            <Heading renderAs="h3">
                {/*[TODO]: to update message based on pill */}
                No content returned
            </Heading>
            <TextAlignCenterDiv>
                <Text>{message}</Text>
            </TextAlignCenterDiv>
        </FullHeightDivFlexCenter>
    );
};
